<template>
  <path pid="0" d="M24 11h-2V9a1 1 0 00-1-1h-.12A1 1 0 0020 9v2h-2a1 1 0 00-1 1v.12a1 1 0 001 .88h2v2a1 1 0 001 1h.12a1 1 0 00.88-1v-2h2a1 1 0 001-1v-.12a1 1 0 00-1-.88zM2 23a1 1 0 001-1v-2a3 3 0 013-3h7a3 3 0 013 3v2a1 1 0 002 0v-2a5 5 0 00-5-5H6a5 5 0 00-5 5v2a1 1 0 001 1zM9.5 13a5 5 0 10-5-5 5 5 0 005 5zm0-8a3 3 0 11-3 3 3 3 0 013-3z"/>
</template>
